<template>
  <logged-in-layout>
    <main>
      <notifications theme="extension"></notifications>
    </main>
  </logged-in-layout>
</template>

<script>
  import LoggedInLayout from '@/components/logged-in-layout/logged-in-layout'
  import { Notifications } from 'vue-components/notifications'

  export default {
    components: {
      LoggedInLayout,
      Notifications
    }
  }
</script>



// WEBPACK FOOTER //
// notifications.vue?13647804